// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internal-signin-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.internal-signin-container .homepage-logo {
  width: 130px;
  position: absolute;
  top: 50px;
  left: 50px;
}
.internal-signin-container .email-row {
  font-size: 14px;
  color: #365A64;
}
.internal-signin-container .internal-signin-box-wrapper {
  padding: 20px;
}
.internal-signin-container .internal-signin-box-wrapper .internal-signin-box {
  background-color: #fff;
  border-radius: 10px;
  width: 490px;
  height: 260px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.internal-signin-container .internal-signin-box-wrapper .internal-signin-box .internal-signin-button {
  cursor: pointer;
  border: 1px solid #E5EDEF;
  border-radius: 73px;
  padding: 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/InternalSignInPage/InternalSignInPage.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;AAEC;EACC,eAAA;EACA,cAAA;AAAF;AAGC;EACC,aAAA;AADF;AAGE;EACC,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AADH;AAGG;EACC,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AADJ","sourcesContent":[".internal-signin-container {\n\tdisplay: flex;\n\theight: 100vh;\n\twidth: 100vw;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.homepage-logo {\n\t\twidth: 130px;\n\t\tposition: absolute;\n\t\ttop: 50px;\n\t\tleft: 50px;\n\t}\n\n\t.email-row {\n\t\tfont-size: 14px;\n\t\tcolor: #365A64;\n\t}\n\n\t.internal-signin-box-wrapper {\n\t\tpadding: 20px;\n\n\t\t.internal-signin-box {\n\t\t\tbackground-color: #fff;\n\t\t\tborder-radius: 10px;\n\t\t\twidth: 490px;\n\t\t\theight: 260px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-around;\n\t\t\talign-items: center;\n\n\t\t\t.internal-signin-button {\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder: 1px solid #E5EDEF;\n\t\t\t\tborder-radius: 73px;\n\t\t\t\tpadding: 0px 10px;\n\t\t\t}\n\t\t}\n\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
